module.exports = __webpack_public_path__ + "static/media/finishing_selected.d3a093dc.svg";